import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal__google-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  role: "presentation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "modal__google-text" }, "Войти при помощи Google", -1)
const _hoisted_3 = { class: "modal__legal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconGoogle = _resolveComponent("IconGoogle")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, { modalName: 'isLoginModalVisible' }, {
    title: _withCtx(() => [
      _createTextVNode(" Войти или зарегистрироваться ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: "modal__google-btn btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signInWithGoogle && _ctx.signInWithGoogle(...args)))
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_1, [
          _createElementVNode("g", null, [
            _createVNode(_component_IconGoogle)
          ])
        ])),
        _hoisted_2
      ]),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(" Регистрируясь на сайте, Вы соглашаетесь с "),
        _createVNode(_component_router_link, {
          onClick: _ctx.closeModalAndNavigation,
          to: "/user-agreement",
          class: "modal__link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("пользовательским соглашением")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createTextVNode(" и "),
        _createVNode(_component_router_link, {
          onClick: _ctx.closeModalAndNavigation,
          to: "/privacy",
          class: "modal__link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("политикой обработки персональных данных")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createTextVNode(". ")
      ])
    ]),
    _: 1
  }))
}